/* ══════════════════════════════════════════════════════════════════
   „Preis immer individuell" am Posten — wann der Preis fehlt.

   Migration 0227, Entscheidung E1 vom 04.10.2026 (Playbook-Durchgang
   03.10.2026: R-12, V-13, V-07, RE-01, V-02). Luca zur Anlieferung: *„es
   gibt keinen festen Preis, der wird immer individuell vergeben."*

   Ein Zuschlag mit dieser Preisart hat keinen Satz im Stamm. Er fehlt,
   solange er dazugehört (nicht abgewählt, nicht „Kunde holt ab") und
   niemand einen Satz genannt hat. Dann heißt er überall „Preis fehlt" —
   nicht 0,00 und nicht 15,00 —, und „Jetzt vermieten" hält an. Ein Angebot
   geht trotzdem („Preis nach Vereinbarung").

   Eine eigene Datei ohne Abhängigkeiten, damit die Regel ohne Browser
   prüfbar ist (`test/preisfehlt.test.ts`).
   ══════════════════════════════════════════════════════════════════ */

/** Was ein Zuschlag an einem Posten dafür trägt — eine Teilmenge von `Merkzuschlag`. */
export type Preisfrage = {
  preisIndividuell?: boolean | undefined;
  aus?: boolean | undefined;
  einzelpreis?: number | undefined;
};

/** Fehlt an diesem Zuschlag der Preis? */
export function preisFehlt(z: Preisfrage): boolean {
  return z.preisIndividuell === true && !z.aus && z.einzelpreis === undefined;
}
